import {create} from 'zustand';
import {SideBarOpenStateStore} from './types';

export const useSideBarOpenStateStore = create<SideBarOpenStateStore>(set => ({
	sideBarOpenState: true,
	setSideBarOpenState: value => set({sideBarOpenState: value}),
}));
